import { IconXmark } from "@/shared";

const closeAction = {
    text: "words.close_action",
    event: "close",
    icon: IconXmark,
    iconWidth: "10px",
    disableCondition: (repair) => repair?.status?.const === "CLOSED",
};

/**
 * Набор действий строки заказа. Удаление показывается только тем, у кого
 * есть право на удаление в разделе «Заказы»: мастер не должен убирать заказ
 * из системы вместе с его историей.
 */
export const buildActions = (canDelete = true) => {
    const list = ["edit", closeAction];

    if (canDelete) {
        list.push("delete");
    }

    return list;
};

export default buildActions(true);
